export const addLogin = login => ({
    type: 'ADD_LOGIN',
    login
});